import React, { Component, PropTypes } from 'react'

class NavItem extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    let currentClass =
      typeof window !== 'undefined' && window.location.pathname == this.props.path ? 'current ' : ''

    if (this.props.className) {
      currentClass += this.props.className
    }

    return (
      <li className={currentClass}>
        <a href={this.props.path}>{this.props.children}</a>
      </li>
    )
  }
}

export default NavItem



// WEBPACK FOOTER //
// ./src/common/ui/components/NavItem.js